import { render, staticRenderFns } from "./AddEmployee.vue?vue&type=template&id=fcb014d6&scoped=true&"
import script from "./AddEmployee.vue?vue&type=script&lang=ts&"
export * from "./AddEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb014d6",
  null
  
)

export default component.exports